import React from "react";
import { Page } from "./Page";

export const RSVP = () => {
  return <Page>Under Construction</Page>;
};
